/**
 * 4.3.10 walkthrough slides.
 *
 * Each slide:
 *   {
 *     image:          public-path string (e.g. '/walkthroughs/4.3.10/foo.png'),
 *     title:          short heading,
 *     body:           one or two sentences describing the change,
 *     minRoleWeight?: integer — only users with role_weight >= this see the slide
 *                     (matches hasMinRole gating; omit for "visible to everyone")
 *     is_cloud_only?: boolean — true hides the slide on 4.0 campuses, for features
 *                     that only exist on the 5.0 cloud architecture. Omitted or
 *                     false means architecture-independent. Evaluated against the
 *                     campus config's `is_cloud` in collectSlides (index.js).
 *     is_grandstream?: boolean — true shows the slide only on Grandstream (intercom)
 *                     campuses, the same check that shows the Call Logs report.
 *     is_ehr_integration?: boolean — true shows the slide only where the EHR Tasks
 *                     page, and its History tab, is available (see index.js).
 *   }
 *
 * Drop walkthrough images under public/walkthroughs/{version}/.
 */
export default [
  {
    image: '/walkthroughs/4.3.10/slide1.png',
    title: 'New Voice Calling Metric, Time to Connect',
    body: 'Time to Connect shows how quickly your caregivers reach a resident by intercom after an alert, measured from the alert to the first call to the resident or their room. You will find it on the Alert Details and Hourly Summary reports, in scheduled reports, and on the Main Dashboard, alongside Intercom Usage, the share of alerts where the intercom was used. Use it to see how fast residents hear a caregiver\'s voice when they call for help.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: true,
    is_grandstream: true
  },{
    image: '/walkthroughs/4.3.10/slide2.png',
    title: 'EHR Tasks Historical View',
    body: 'The EHR Tasks page now has a History tab with every resident and staff task that was approved, auto-approved, or rejected, and who decided it and when. Open any entry to see exactly what changed, or for a rejected task, what was proposed and why. Search, filter, and export to CSV, so you always have a clear record of the updates coming from your EHR.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false,
    is_ehr_integration: true
  }
];
